import React from 'react';
import styled from 'styled-components';
import { RadioInput } from './reportPanel.style';
import theme from 'src/theme';

const CargoNameTypeContainer = styled.div`
    display: flex;
    gap: 15px;
    margin-top: 8px;
    margin-bottom: 8px;
`;

const CargoNameTypeLabel = styled.label<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    color: ${theme.colors.text.blueLink};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

interface CargoNameTypeSelectorProps {
    cargoNameType: string;
    setCargoNameType: (value: string) => void;
    disabled?: boolean;
}

const CargoNameTypeSelector: React.FC<CargoNameTypeSelectorProps> = ({ cargoNameType, setCargoNameType, disabled }) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled) {
            setCargoNameType(event.target.value);
        }
    };
    return (
        <CargoNameTypeContainer>
            <CargoNameTypeLabel disabled={disabled}>
                <RadioInput
                    type="radio"
                    name="cargoNameType"
                    value="tradeName"
                    checked={cargoNameType === 'tradeName'}
                    onChange={handleChange}
                    disabled={disabled}
                />
                Trade Name
            </CargoNameTypeLabel>
            <CargoNameTypeLabel disabled={disabled}>
                <RadioInput
                    type="radio"
                    name="cargoNameType"
                    value="productName"
                    checked={cargoNameType === 'productName'}
                    onChange={handleChange}
                    disabled={disabled}
                />
                Product Name
            </CargoNameTypeLabel>
        </CargoNameTypeContainer>
    );
};

export default CargoNameTypeSelector;
